/**
 * Module definition houses storage implementation.
 *
 * @module stack.common.storage
 */
angular.module('stack.common.storage', [
  'stack.common.storage.services.CookieStorageService',
  'stack.common.storage.services.LocalStorageService',
  'stack.common.storage.services.StorageParserService',
  'stack.common.storage.services.StorageStrategyService'
]);
